<div class="data-panel m-auto flex w-full flex-col">

  <!-- Title + version selector -->
  <div class="page-section-header mb-6">
    <div>
      <p class="page-section-kicker">Questionnaire analytics</p>
      <h1 class="page-section-title">{{ questionnaireTitle() }}</h1>
      <p class="page-section-description">
        Switch versions and review insights, summaries, and individual
        responses for this questionnaire.
      </p>
    </div>
    @if (questionnaireVersions.value(); as questionnaireVersions) {
      <div class="relative flex items-center">
        <select
          [ngModel]="selectedVersion()"
          (ngModelChange)="selectVersion($event)"
          class="form-control h-[42px] min-w-[220px] rounded-full py-2 pl-4 pr-8 text-[14px]">
          @if (!isSummariesPage()) {
            <option value="undefined">All Versions</option>
          }
          @for (version of questionnaireVersions; track version.versionValue) {
            <option [value]="version.versionValue">
              {{ version.versionName }}{{ version.isLatest ? ' (Latest)' : '' }}
            </option>
          }
        </select>
        <span
          class="material-symbols-outlined pointer-events-none absolute right-2 text-[18px] text-support-text"
        >
          expand_more
        </span>
      </div>
    }
  </div>

  <!-- Tab navigation -->
  <div class="mb-4 flex justify-center">
    <div class="flex gap-1 rounded-full bg-surface-muted p-1">
      <div
        [queryParams]="{selectedVersion: selectedVersion()}"
        [routerLinkActive]="['!bg-surface-background', '!text-inverted-neutral']"
        class="cursor-pointer font-spaceGrotesk text-[14px] px-5 py-2 rounded-full text-base-200 hover:text-support-text transition-colors whitespace-nowrap"
        routerLink="insights">
        Insights + Trends
      </div>
      <div
        [queryParams]="{selectedVersion: selectedVersion()}"
        [routerLinkActive]="['!bg-surface-background', '!text-inverted-neutral']"
        class="cursor-pointer font-spaceGrotesk text-[14px] px-5 py-2 rounded-full text-base-200 hover:text-support-text transition-colors"
        routerLink="summaries">
        Summaries
      </div>
      <div
        [queryParams]="{selectedVersion: selectedVersion()}"
        [routerLinkActive]="['!bg-surface-background', '!text-inverted-neutral']"
        class="cursor-pointer font-spaceGrotesk text-[14px] px-5 py-2 rounded-full text-base-200 hover:text-support-text transition-colors whitespace-nowrap"
        routerLink="responses">
        Individual Responses
      </div>
    </div>
  </div>

  <!-- Page Content -->
  <router-outlet />
</div>
